import React, { useContext, useEffect, useRef } from 'react'
import PiperChart from './PiperChart'
import { DataContext } from './DataContext'
import FilterModeSelector from '../box-plot/FilterModeSelector'
import PiperHeader from './PiperHeader'

//https://2019.wattenberger.com/blog/react-and-d3#sizing-responsivity
const PiperChartWrapper = () => {
    const ref = useRef(null)
    const chartRef = useRef(null)
    const {
        isCollapsed,
        filterMode,
        setFilterMode,
        displayFilterModeDropdown,
        setDisplayFilterModeDropdown,
        containerDimensions,
        setContainerDimensions,
    } = useContext(DataContext)

    useEffect(() => {
        // if (isExpanded) {
        const r = ref.current
        setContainerDimensions({
            width: 600, // r.clientWidth,
            height: 600, //r.clientHeight
        })
        // setHeight(r.clientHeight)
        // setWidth(r.clientWidth - 40)
        // }
    }, [setContainerDimensions, ref])

    return (
        <div
            ref={ref}
            className={`explorerWrapper ${
                ``
                // isExpanded ? `fullscreen-overlay` : ``
            }`}
        >
            <PiperHeader chartRef={chartRef} />
            <div className={`${isCollapsed ? 'is-collapsed' : ''}`}>
                <FilterModeSelector
                    chartRef={chartRef}
                    displayFilterModeDropdown={displayFilterModeDropdown}
                    setDisplayFilterModeDropdown={setDisplayFilterModeDropdown}
                    setFilterMode={setFilterMode}
                    filterMode={filterMode}
                />
                <div ref={chartRef} className={`piperWrapper`}>
                    <PiperChart />
                </div>
            </div>
        </div>
    )
}

export default PiperChartWrapper
